import React from 'react'

export default function FiltersBar({children, className = '', ... other}) {
  let defaultClasses = 'bg-light-gris-blue p-2 d-flex align-items-center';

  return <div className={`${defaultClasses} ${className}`} {...other}>
    { children }
  </div>
}
